<script setup>
import '@campact/camper/core/CmprSelectControl.css';
import { CMPR_INTERACT_EVENT, dispatchCmprEvent } from '@campact/camper/utils';

const model = defineModel({ type: String });

function dispatchCmprSelectFocus({ target }) {
  dispatchCmprEvent(target, CMPR_INTERACT_EVENT, {
    camperWebComponent: 'cmpr-select',
    event: 'cmpr-select-focus',
  });
}
</script>

<template>
  <select
    v-model="model"
    class="cmpr-select-control"
    @focus="dispatchCmprSelectFocus($event)"
  >
    <slot />
  </select>
</template>
